import React from "react";
import PropTypes from "prop-types";

const AuthContext = React.createContext({ prefix: null });

export const useAuthContext = () => React.useContext(AuthContext);

function AuthProvider(props) {
  return <AuthContext.Provider value={{ prefix: props.prefix }}>{props.children}</AuthContext.Provider>;
}

AuthProvider.defaultProps = {};

AuthProvider.propTypes = {
  prefix: PropTypes.string.isRequired,
};

export default AuthProvider;
